import { EyeSlashIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { FC } from "react";

import { cn } from "helpers/classNames";
import { HasSentStatus } from "types/transportDocument.type";

interface Props {
  status: HasSentStatus;
  className?: string;
}

const containerBaseClass =
  "inline-flex items-center gap-x-0.5 rounded-md pl-1.5 pr-2 py-1 text-xs font-medium ring-1 ring-inset";
const iconBaseClass = "group relative -ml-1 h-3.5 sm:h-4 w-auto rounded-sm";

export const SentToCustomerStatusTag: FC<Props> = ({ status, className }) => (
  <span
    className={cn(
      containerBaseClass,
      getSendToCustomerStatusTagContainerClass(status),
      className,
    )}
  >
    <SendToCustomerStatusIcon status={status} />
    {getSendToCustomerStatusLabel(status)}
  </span>
);

export const getSendToCustomerStatusTagContainerClass = (
  status: HasSentStatus,
) => {
  switch (status) {
    case HasSentStatus.Ignored:
      return "bg-gray-50 text-gray-900 ring-gray-600/10";
    // case HasSentStatus.Started:
    //   return "bg-blue-50 text-blue-900 ring-blue-600/10";
    case HasSentStatus.Sent:
      return "bg-cyan-50 text-cyan-900 ring-cyan-400/20";
  }
};

export const SendToCustomerStatusIcon: FC<Props> = ({ status, className }) => (
  <>
    {status === HasSentStatus.Ignored ? (
      <EyeSlashIcon
        className={cn("text-gray-400", iconBaseClass, className)}
        aria-hidden="true"
      />
    ) : // ) : status === HasSentStatus.Started ? (
    //   <ClipboardIcon
    //     className={cn("text-blue-400", iconBaseClass, className)}
    //     aria-hidden="true"
    //   />
    status === HasSentStatus.Sent ? (
      <EnvelopeIcon
        className={cn("text-cyan-600", iconBaseClass, className)}
        aria-hidden="true"
      />
    ) : (
      "missing"
    )}
  </>
);

export const getSendToCustomerStatusLabel = (status: HasSentStatus) => {
  switch (status) {
    case HasSentStatus.Ignored:
      return "Påminnelse ignorerad";
    // case HasSentStatus.Started:
    //   return "Påbörjat";
    case HasSentStatus.Sent:
      return "Skickad";
  }
};
